import { any, isNil, prop } from 'ramda';

export const schemaBarParser = (chartData) => {
  const series = chartData.series.reduce((list, serie) => {
    if (!serie.match(/c\d+/g)) {
      list.push(serie);
    } else {
      const data = chartData.data.map(prop(serie));
      const hasValues = any((value) => !isNil(value))(data);

      if (hasValues) {
        list.push(serie);
      }
    }

    return list;
  }, []);

  chartData.series = series;
};
